module.exports = __webpack_public_path__ + "static/img/Ellipse 118.3f90313.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 118.png
// module id = gSh6
// module chunks = 1